// extracted by mini-css-extract-plugin
export var chalkVideo = "styles-module--chalkVideo--dbd86";
export var container = "styles-module--container--30e5f";
export var hidden = "styles-module--hidden--49d3a";
export var imageViewContainer = "styles-module--imageViewContainer--34f26";
export var open = "styles-module--open--3e5ba";
export var willOpen = "styles-module--willOpen--539fb";